<template>
  <div class="section">
    <div class="level">
      <div class="level-left"><h1 class="title">Missing Names Report</h1></div>
      <div class="level-right">
        <b-dropdown class="is-hidden-desktop">
          <template #trigger>
            <a class="navbar-item" role="button">
              <span>Options</span>
              <b-icon icon="menu-down"></b-icon>
            </a> </template
          ><b-dropdown-item aria-role="listitem" @click="ApproveSelected()">Approve Selected ({{ this.checkedRows.length }})</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" @click="DeleteSelected()">Delete Selected ({{ this.checkedRows.length }})</b-dropdown-item></b-dropdown
        >
      </div>
    </div>
    <div class="columns">
      <div class="column is-three-quarters-desktop">
        <div class="box">
          <b-table
            :data="this.missingNames"
            default-sort="times_used"
            default-sort-direction="desc"
            paginated
            backend-pagination
            :per-page="perPage"
            :current-page.sync="page"
            :total="total"
            detailed
            @details-open="(row) => openDetail(row)"
            @page-change="GetMissingNames()"
            checkable
            :checked-rows.sync="checkedRows"
          >
            <b-table-column name="name" label="Name" v-slot="props" sortable>
              {{ props.row.name }}
            </b-table-column>
            <b-table-column name="times_used" label="Times Used" v-slot="props" width="120" sortable>
              {{ props.row.times_used }}
            </b-table-column>
            <b-table-column v-slot="props" width="0">
              <div class="is-flex" style="gap: 10px">
                <template v-if="props.row.deleted == 'false'">
                  <b-button v-if="props.row.approved != 'true'" type="is-success" icon-left="plus" @click="AddGlobalName(props.row, $event)" :loading="props.row.approved == 'loading'"
                    >Add to global names</b-button
                  >
                  <b-button v-else type="is-success" icon-left="check">Added</b-button>
                </template>
                <template v-if="props.row.approved == 'false'">
                  <b-button v-if="props.row.deleted != 'true'" type="is-danger" icon-left="delete" @click="DeleteMissingName(props.row.name)" :loading="props.row.deleted == 'loading'"
                    >Delete Name</b-button
                  >
                  <b-button v-else type="is-danger" icon-left="check">Name Deleted</b-button>
                </template>
              </div>
            </b-table-column>
            <template slot="detail">
              <table v-if="!detailLoading" style="width: unset">
                <thead>
                  <tr>
                    <td>Company Name</td>
                    <td>Times Used</td>
                  </tr>
                </thead>
                <tr class="block" v-for="count in openedDetail.company_counts" :key="count.company_id">
                  <td class="name">{{ GetCustomerName(count.company_id) }}:</td>
                  <td class="value">{{ count.count }}</td>
                </tr>
              </table>
            </template>
          </b-table>
        </div>
      </div>
      <div class="column is-hidden-touch">
        <div class="box is-flex is-flex-direction-column">
          <b-button type="is-success" :disabled="this.checkedRows.length < 1" @click="ApproveSelected()">Approve Selected ({{ this.checkedRows.length }})</b-button>
          <b-button type="is-danger" :disabled="this.checkedRows.length < 1" @click="DeleteSelected()">Delete Selected ({{ this.checkedRows.length }})</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data: function () {
    return {
      missingNames: [],
      loading: true,
      newApiUrl: "https://api.jeak.co.uk",
      perPage: 50,
      page: 1,
      total: 0,
      openedDetail: {},
      customers: [],
      detailLoading: true,
      checkedRows: [],
    };
  },
  methods: {
    async GetMissingNames() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const response = await axios.get(`${this.newApiUrl}/stats/missing-names?perPage=${this.perPage}&page=${this.page}`, config);
      this.$set(this, "missingNames", response.data.data);
      this.total = response.data.total;
      for (let i in this.missingNames) {
        this.$set(this.missingNames[i], "approved", "false");
        this.$set(this.missingNames[i], "deleted", "false");
      }
      this.loading = false;
    },
    AddGlobalName: async function (name, event) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const body = {
        name: name.name,
      };
      name.approved = "loading";
      axios
        .post(`${this.newApiUrl}/names`, body, config)
        .then(() => {
          name.approved = "true";
        })
        .catch(() => {
          name.approved = "false";
          this.$buefy.toast.open({
            message: `Could not add ${name.name} to global names!`,
            type: "is-danger",
          });
        });
    },
    DeleteMissingName: async function (name) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      name.deleted = "loading";
      await axios.delete(`${this.newApiUrl}/stats/missing-name/${encodeURI(name.name)}`, config);
      name.deleted = "true";
    },
    async openDetail(row) {
      this.detailLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };

      const res = await axios.get(`${this.newApiUrl}/stats/missing-name/${encodeURI(row.name)}`, config);

      this.openedDetail = res.data;
      this.detailLoading = false;
    },
    async GetCustomers() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const res = await axios.get(this.newApiUrl + "/customers", config);
      this.customers = res.data;
    },
    GetCustomerName(id) {
      for (const customer of this.customers) {
        if (customer.disctools_id == id) return customer.customer_name;
      }

      return "id - " + id;
    },
    async ApproveSelected() {
      this.$buefy.dialog.confirm({
        title: "Confirm Approve",
        message: `<p class="has-text-centered">Are you sure you would like to bulk approve ${this.checkedRows.length} names?`,
        type: "is-success",
        confirmText: "Approve Names",
        onConfirm: () =>
          this.checkedRows.forEach((row) => {
            this.AddGlobalName(row);
          }),
      });
    },
    async DeleteSelected() {
      this.$buefy.dialog.confirm({
        title: "Confirm Delete",
        message: `Are you sure you would like to bulk delete ${this.checkedRows.length} names?`,
        type: "is-danger",
        confirmText: "Delete Names",
        onConfirm: () =>
          this.checkedRows.forEach((row) => {
            this.DeleteMissingName(row);
          }),
      });
    },
    ConfirmMessage() {},
  },
  async mounted() {
    await this.GetCustomers();
    await this.GetMissingNames();
  },
};
</script>

<style scoped>
.name-wrap {
  max-width: 1200px;
}
.box.is-flex {
  max-width: 350px;
  gap: 10px;
}
</style>
